export function bold(html) {
    return `<b>${html}</b>`;
}

export function escapeHTML(unsafeText) {
    let div = document.createElement('div');
    div.innerText = unsafeText;
    return div.innerHTML;
}
